const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ==========================================================================
   INICIO — EMMA SANTINI: al CLICAR un color en la tarjeta de coleccion,
   la foto cambia a la prenda de ese color y el enlace abre ese color.
   (No hace nada al pasar el raton por encima.)
   Para revertir, borra desde aqui hasta el comentario FIN.
   ========================================================================== */
(function () {
  var cache = {};

  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function pickVariant(variants, value) {
    var i;
    for (i = 0; i < variants.length; i++) {
      if (variants[i].options.indexOf(value) !== -1 && variants[i].available) return variants[i];
    }
    for (i = 0; i < variants.length; i++) {
      if (variants[i].options.indexOf(value) !== -1) return variants[i];
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var node = event.target;
      if (!node || !node.closest) return;

      var item = node.closest('li.swatch-view-item');
      if (!item || item.classList.contains('minification-btn')) return;

      var card = item.closest('.product-card-wrapper');
      if (!card) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      var parts = link.getAttribute('href').split('/products/');
      if (parts.length < 2) return;
      var handle = parts[1].split('?')[0].split('#')[0];

      var value = item.getAttribute('orig-value') || item.getAttribute('aria-label');
      if (!value) return;

      event.preventDefault();
      event.stopPropagation();

      getProduct(handle).then(function (data) {
        if (!data || !data.variants) return;

        var variant = pickVariant(data.variants, value);
        if (!variant) return;

        var src = variant.featured_image && variant.featured_image.src;
        if (src) {
          var media = card.querySelector('.card__media .media');
          if (media) media.classList.remove('media--hover-effect');

          var images = card.querySelectorAll('.card__media img');
          for (var k = images.length - 1; k >= 0; k--) {
            if (k === 0) {
              images[k].removeAttribute('srcset');
              images[k].removeAttribute('sizes');
              images[k].setAttribute('src', src);
            } else {
              images[k].parentNode.removeChild(images[k]);
            }
          }
        }

        var links = card.querySelectorAll('a[href*="/products/"]');
        for (var m = 0; m < links.length; m++) {
          links[m].setAttribute('href', links[m].getAttribute('href').split('?')[0] + '?variant=' + variant.id);
        }

        var group = item.parentElement;
        if (group) {
          var selected = group.querySelectorAll('.swatch-selected');
          for (var n = 0; n < selected.length; n++) selected[n].classList.remove('swatch-selected');
        }
        var mark = item.querySelector('.swatch-selector');
        if (mark) mark.classList.add('swatch-selected');
      });
    },
    true
  );
})();
/* ==========================================================================
   FIN — EMMA SANTINI
   ========================================================================== */